import React, { Component } from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Label, Tooltip } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { FRONT_END_URL } from '../../../../../utils/Constants';

class ProductImage extends Component {
    renderImage() {
        const { label, figure } = styles;
        const { imagePreview, currentProduct } = this.props;
        let imageSrc;
        let labelStyle;
        let imgStyle;
        const currentImageUrl = this.props.isLargeImageDesign ? currentProduct.rectImageUrl : currentProduct.imageUrl;

        if (imagePreview !== null) {
            imageSrc = imagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (currentProduct.imageUrl === null && currentProduct.rectImageUrl === null) {
            imageSrc = imagePreview;
            labelStyle = 'coloured-label'
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (currentImageUrl) {
            imageSrc = `${FRONT_END_URL}/${currentImageUrl}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <AvGroup style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'space-between' }}>
                <Label style={{maxWidth: '25%'}}>{i18n.t('common:form.imgUrl')}</Label>
                <figure style={figure}>
                    <AvInput type="file" required={false} className="custom-file-input" name="imageUrl" id="imageUrl" onChange={(event) => this.props.uploadImage(event)} />
                    <label className={labelStyle} style={label} htmlFor="imageUrl">
                        <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center' }}>
                            <span><MaterialIcon icon="local_see" /></span>
                            {i18n.t('screens:productScreen.uploadImage')}
                            <div style={{ fontSize: 12 }}>{i18n.t(`screens:productScreen.${this.props.isLargeImageDesign ? 'specificationsLargeImages' : 'specifications'}`)}</div>
                        </div>
                    </label>
                    <img style={imgStyle} src={imageSrc} />
                </figure>
                <div id='deleteProductImageButton' style={{ marginRight: 10 }} >
                    <span style={{ cursor: 'pointer' }} onClick={this.props.deleteProductImage}>
                        <MaterialIcon icon="delete_outline" color="#cdcdcd" size={26} />
                    </span>
                    {
                        this.props.includeTooltip ?
                            <Tooltip disabled={false} placement="top" isOpen={this.props.showDeleteImageTooltip} target="deleteProductImageButton" toggle={this.props.toggleDeleteImageTooltip}>
                                {i18n.t('screens:productScreen.deleteImg')}
                            </Tooltip> : null
                    }
                </div>
            </AvGroup>
        )
    }

    render() {
        return this.renderImage();
    }
}

export default ProductImage;

const styles = {
    label: {
        fontSize: 15,
        width: '45%',
        transform: 'translate(-35%)'
    },

    figure: {
        display: 'flex',
        height: 250,
        width: 250,
        overflow: 'hidden',
        background: '#F8F8F8',
        marginBottom: 0
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/additionalInformation/ProductImage.js